export interface IRemoveEpcCalculationRequest {
  epcCalculationId: number;
  partnerSystemNumber: string;
}

export class RemoveEpcCalculationRequest
  implements IRemoveEpcCalculationRequest {
  epcCalculationId: number;
  partnerSystemNumber: string;

  constructor(epcCalculationId: number, partnerSystemNumber: string) {
    this.epcCalculationId = epcCalculationId;
    this.partnerSystemNumber = partnerSystemNumber
  }
}

